/** Ranked placement cards the guided generate step shows (A/B/C carousel).
 *  Backend chart/viz attach and job-wire trim use the same count — keep
 *  `backend/placement_constants.py` in sync when changing this. */
export const PLACEMENT_GALLERY_LIMIT = 3;
